import { useState } from "react";
import { Eye, EyeOff } from "react-feather"
import { loginUser } from "../../../../../helper/Context/action";
import { useAuthDispatch } from "../../../../../helper/Context/context";
import { AcademyRegistrationForm } from "../../../../Registration/AcademyRegistrationForm";

export const UserLogin = ({ onLoginSuccess,name }) => {
    const dispatch = useAuthDispatch();
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loginMessage, setLoginMessage] = useState("");
    const [showRegistration, setShowRegistration] = useState(false);

    const handleLogin = async (event) => {
        event.preventDefault();
        setLoginMessage("");

        try {
            await loginUser(dispatch, {
                UserName: userName,
                Password: password,
                setloading: setLoading,
                handleRollIdWiseDashboard: (data) => {
                    if (data?.access_token && data?.RoleID != 1) {
                        onLoginSuccess();
                    }else{
                        setLoginMessage("Unauthorized user!"); 
                    }
                },
                handleErrorIdWiseDashboard: (message) => {
                    setLoginMessage(message || "Unable to sign in. Please try again.");
                },
                setLoginmessage: (message) => {
                    setLoginMessage(message || "Unable to sign in. Please check your credentials.");
                },
            });
        } catch {
            setLoginMessage("Unable to sign in right now. Please try again later.");
        }
    };

    return (
        <section
            className="mx-auto my-5 p-3 p-md-4 shadow-sm"
            aria-labelledby="webinar-login-heading"
            style={{
                maxWidth: 580,
                border: "1px solid #e2e8ec",
                borderRadius: 16,
                background: "#fff",
            }}
        >
            <p
                className="fw-bold text-uppercase mb-2"
                style={{ color: "#cd9e53", letterSpacing: "0.12em" }}
            >
                MILSO Academy
            </p>
            {showRegistration ? (
                <AcademyRegistrationForm onBackToLogin={() => setShowRegistration(false)} />
            ) : (
                <>
                    <h2 id="webinar-login-heading" className="fw-bold mb-2" style={{ color: "#16374e" }}>
                        Sign in to view {name}
                    </h2>
                    <p className="text-muted mb-4">
                        Sign in to access webinar playback and purchase options.
                    </p>

                    <form onSubmit={handleLogin}>
                        <div className="mb-3">
                            <label htmlFor="webinar-username" className="form-label fw-semibold">
                                Username
                            </label>
                            <input
                                id="webinar-username"
                                type="text"
                                className="form-control"
                                autoComplete="username"
                                value={userName}
                                onChange={(event) => setUserName(event.target.value)}
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="webinar-password" className="form-label fw-semibold">
                                Password
                            </label>
                            <div className="input-group">
                                <input
                                    id="webinar-password"
                                    type={showPassword ? "text" : "password"}
                                    className="form-control"
                                    autoComplete="current-password"
                                    value={password}
                                    onChange={(event) => setPassword(event.target.value)}
                                    required
                                />
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary"
                                    onClick={() => setShowPassword((visible) => !visible)}
                                    aria-label={showPassword ? "Hide password" : "Show password"}
                                    aria-pressed={showPassword}
                                >
                                    {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                </button>
                            </div>
                        </div>

                        {loginMessage && (
                            <p className="text-danger mb-3" role="alert">
                                {loginMessage}
                            </p>
                        )}

                        <button
                            type="submit"
                            className="btn fw-semibold w-100 py-2"
                            disabled={loading}
                            style={{ backgroundColor: "#16374e", color: "#fff" }}
                        >
                            {loading ? "Signing in..." : "Login"}
                        </button>
                    </form>

                    <div className="d-flex justify-content-between flex-wrap gap-2 mt-4">
                        <a href="mailto:milsoconnect1@gmail.com?subject=Forgot%20webinar%20login%20password">
                            Forgot password?
                        </a>
                        <button
                            type="button"
                            className="academy-registration-link"
                            onClick={() => setShowRegistration(true)}
                        >
                            Register
                        </button>
                    </div>
                    <p className="small text-muted mt-3 mb-0">
                        Registration form currently validates your details only; account creation requires the registration service.
                    </p>
                </>
            )}
        </section>
    );
};
